import { render, staticRenderFns } from "./PdpPriceTooltip.vue?vue&type=template&id=cc944a26&"
import script from "./PdpPriceTooltip.vue?vue&type=script&lang=js&"
export * from "./PdpPriceTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports